{
  "Yapılacaklar": "To Do",
  "yapilacaklar": {
    "Oluşturma Tarih": "Creation Date",
    "Yapılacaklar": "To Do",
    "yapilacaklar": "yapilacaklar",
    "talep_takip": "talep_takip",
    "Talep Edilen": "Talep Edilen",
    "Talep Durumu": "Talep Durumu",
    "Talep Notu": "Talep Notu",
    "Sonuç Tarih": "Sonuç Tarih",
    "Sonuç": "Result",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Durum": "Status",
    "Konu": "Subject",
    "Yenile": "Refresh",
    "Yeni": "New",
    "Güncelle": "Update",
    "Kaydet": "Save",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Not": "Note"
  }
}
